"use client";

import React from 'react';
import { RxMagnifyingGlass, RxCross2 } from "react-icons/rx";

export function ImageModal({ isOpen, onClose, imageSrc, altText }) {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="relative max-w-7xl w-full">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white hover:text-gray-300 z-10"
          aria-label="Close modal"
        >
          <RxCross2 className="w-8 h-8" />
        </button>
        <img
          src={imageSrc}
          alt={altText}
          className="max-w-[90vw] max-h-[100vh] w-auto h-auto object-contain mx-auto"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );
}

export function ImageWithZoom({ src, alt, className }) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <div className="relative group">
      <img
        src={src}
        alt={alt}
        className={className}
      />
      <button
        onClick={() => setIsModalOpen(true)}
        className="absolute top-2 right-2 bg-white bg-opacity-75 p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
        aria-label="View full size"
      >
        <RxMagnifyingGlass className="w-5 h-5" />
      </button>
      <ImageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        imageSrc={src}
        altText={alt}
      />
    </div>
  );
}
